var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topNav',{attrs:{"title":"消息通知","border":true}}),_c('noneHint',{attrs:{"img":_vm.hintimg,"hint":"小可愛暫時無消息哦~~"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }